import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
const IOSSwitch = styled((props) => (_jsx(Switch, { disableRipple: true, ...props })))(() => ({
    width: 46,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(20px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#ff008e',
                opacity: 1,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 22,
        height: 22,
        borderRadius: '50%',
        backgroundColor: '#fff',
        boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#e5e7eb',
        opacity: 1,
        transition: 'background-color 300ms',
    },
}));
export default IOSSwitch;
